import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Icon, SelectionList, Text, Tooltip, } from '@dixa/lib-shared-habla';
function renderItem(item) {
    const { value, title, icon, disabled, tooltip } = item;
    return (_jsx(Tooltip, Object.assign({ content: tooltip, dark: true }, { children: _jsx(SelectionList.Item, Object.assign({ value: value, isDisabled: disabled }, { children: _jsx(Content, { title: title, icon: icon }) })) }), `${item.value}--item`));
}
function renderList(item) {
    const { value, title, icon, items, tooltip } = item;
    const parentItem = (_jsx(Tooltip, Object.assign({ content: tooltip, dark: true }, { children: _jsx(SelectionList.Item, Object.assign({}, (value && { value }), { children: _jsx(Content, { title: title, icon: icon }) })) }), `${item.value}--item`));
    return (_jsx(SelectionList.List, Object.assign({ parentItem: parentItem, listProps: { style: { minWidth: '250px' } } }, { children: items.map(renderItemOrList) }), `${value}--list`));
}
const Content = ({ title, icon }) => (_jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "10px" }, { children: [icon && (_jsx(FlexBox, Object.assign({ flex: "0 0 16px" }, { children: _jsx(Icon, { name: icon }) }))), _jsx(FlexBox, Object.assign({ flex: "1 1 auto", style: {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
            } }, { children: _jsx(Text.Paragraph, { children: title }) }))] })));
export function renderItemOrList(item) {
    if (isLeafItem(item)) {
        return renderItem(item);
    }
    return renderList(item);
}
export function isLeafItem(item) {
    return !('items' in item);
}
